import { RestApiResponse } from "./RestApi";
import { BaseResponseAttributes } from "../attributes/base-attributes";
import BaseService from "./BaseService";

export class CurrencyService extends BaseService {
  static async supportedCurrencies(): Promise<
    RestApiResponse<BaseResponseAttributes>
  > {
    return CurrencyService.getPublicApiClient().get("currencies");
  }
}

export default CurrencyService;
